import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Alert,
    AlertColor,
    AlertPropsVariantOverrides,
    Box,
} from "@mui/material";
import axiosInstance from "../../services/axios-instance";
import TextField from '@mui/material/TextField';
import RequestDaysComponent from "./RequestDaysComponent";
import { DateObject } from "react-multi-date-picker";
import { OverridableStringUnion } from "@mui/types";

interface Client {
    id: number;
    name: string;
    pivot: any[];
}

interface ManageClientsProps {
    userId: number;
    userName?: string;
    onClose: () => void;
    setRefetchUsers: (value: boolean) => void;
}

const ManageUserClients: React.FC<ManageClientsProps> = ({
    userId,
    userName,
    onClose,
    setRefetchUsers,
}) => {
    const dialogPaperStyle = {
        minWidth: '600px',
        minHeight: '200px',
        overflow: "visible",
      };
    
    const [clients, setClients] = useState<Client[]>([]);
    const [hours, setHours] = useState(0);
    const [addClient, setAddClient] = useState("");
    const [selectedClients, setSelectedClients] = useState<any[]>([]);
    const [dateValue, setDateValue] = useState<string[]>([]);
    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState<AlertColor | undefined>("info");
    const [variant, setVariant] = useState<
        | OverridableStringUnion<
              "standard" | "filled" | "outlined",
              AlertPropsVariantOverrides
          >
        | undefined
    >("filled");

    const onChangeDateValue = (event: DateObject[]) => {
        const from_date = event[0]?.toLocaleString();
        const to_date = event[1]?.toLocaleString();
        setDateValue([from_date, to_date]);
    };
    
    useEffect(() => {
        fetchUserClients(userId);
        fetchAllClients();
    }, [userId]);

    const fetchAllClients = async () => {
        try {
            const response = await axiosInstance.get("/clients");
            setClients(response.data.data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const fetchUserClients = async (userId: number) => {
        try {
            const response = await axiosInstance.get(
                `/users/${userId}/clients`
            );
            const userClientIds = response.data.map((client: any) => {
                return {
                    id: client.pivot.client_id,
                    hours: client.pivot.hours,
                    from_date: client.pivot.from_date,
                    to_date: client.pivot.to_date
                };
            });
            setSelectedClients(userClientIds);
            console.log(userClientIds)
        } catch (error) {
            console.error(
                `Error fetching user clients for user ID ${userId}:`,
                error
            );
        }
    };

    const handleHoursChange = (value: string) => {
       setHours(+value);
    };

    const handleClientSelect = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setAddClient(event.target.value);
        const existingclient = selectedClients.find(client => client.id === event.target.value);
        if (existingclient) {
            setHours(existingclient.hours);
            if(existingclient.from_date && existingclient.to_date) {
                setDateValue([
                    existingclient.from_date,
                    existingclient.to_date,
                ]);
            }
            else {
                setDateValue([]);
            }

        }
    };

    const handleSave = async () => {

        if(!addClient) {
            setAlertMessage("Client field is required");
            setSeverity("error");
            setVariant("filled");
            return;
        }
        else {
            setAlertMessage("");
        }

        try {

            const responseUpdateclients = await axiosInstance.post(`/users/${userId}/clients`, {
                hours: hours,
                client: addClient,
                dates: dateValue,
            })
            fetchUserClients(userId);
            console.log(responseUpdateclients);

        } catch (error) {
            console.error(
                "An error occurred during the user info update:",
                error
            );
        }
        setRefetchUsers(true);
        onClose();
    };

    return (
        <>
            <Dialog  PaperProps={{ style: dialogPaperStyle }} open={true} onClose={onClose}>
                <DialogTitle>Manage {userName} clients</DialogTitle>

                <DialogContent>
                <div style={{ display: "flex" , flexWrap: "wrap", gap: "1rem", alignItems: "center"}}>

                <FormControl style={{ flex: '0 0 70%'}} required>
                    <InputLabel>Client </InputLabel>
                    <Select
                            name="client_id"
                            label="Client"
                            onChange={handleClientSelect}
                        >
                            {clients.map((client) => (
                                <MenuItem key={client.id} value={client.id}>
                                    {client.name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
                    <TextField
                        sx={{ flex: "0 0 20%", marginTop: "0.5rem" }}
                        label="Hours"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        type="number"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={hours}
                        inputProps={{
                        min: 1,
                        step: 1,
                        }}
                        onChange={(e) =>
                            handleHoursChange(e.target.value)
                        }
                    />
                   <RequestDaysComponent
                        dateValue={dateValue}
                        onChangeDateValue={
                            onChangeDateValue
                        }
                    />
                    </div>
                </DialogContent>

                <Box sx={{ m: "1rem" }}>
                    {alertMessage != "" && (
                        <Alert
                            onClick={() => setAlertMessage("")}
                            variant={variant}
                            severity={severity}
                        >
                            {alertMessage}
                        </Alert>
                    )}
                </Box>
                
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        onClick={handleSave}
                        variant="contained"
                        color="primary"
                    >
                        Save Changes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ManageUserClients;
